module.exports = __webpack_public_path__ + "img/nostromo_min.1d175491.jpeg";